module.exports = __webpack_public_path__ + "static/media/fermer-recherche.2d4b37f7.png";